import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { IFarmLandsState } from "../shared/interfaces/farm-lands-state";
import { FarmLand } from "../shared/models/farm-land";

import { farmLandsApi } from "./farm-lands.rtkq";

const initialState: IFarmLandsState = {
  item: null,
  isLoading: false,
  list: [],
  listCount: 0,
};
export const FIELDS_MODULE_NAME = "farmLands";
export const farmLandsSlice = createSlice({
  name: FIELDS_MODULE_NAME,
  initialState,
  reducers: {
    setListAction(state, action: PayloadAction<FarmLand[]>): void {
      state.list = action.payload;
    },
    setListCountAction(state, action: PayloadAction<number>): void {
      state.listCount = action.payload;
    },
    setDetailsAction(state, action: PayloadAction<FarmLand | null>): void {
      state.item = action.payload;
    },
    clearDetailsAction(state): void {
      state.item = null;
    },
  },
});

export const farmLandsReducer = farmLandsSlice.reducer;
export const { setListAction, setDetailsAction, clearDetailsAction, setListCountAction } =
  farmLandsSlice.actions;

export const fetchFarmLandByIdAction = createAsyncThunk<
  void,
  string,
  { rejectValue: number }
>(
  `${FIELDS_MODULE_NAME}/fetchFarmLandById`,
  async (id, { dispatch, rejectWithValue, signal }) => {
    if (id === null) {
      return;
    }

    try {
      const dto = await dispatch(
        farmLandsApi.endpoints.fetchFarmLandById.initiate(id, {
          subscribe: false,
          forceRefetch: true,
        })
      ).unwrap();
      if (signal.aborted) return;
      const model = new FarmLand();
      model.updateFromDto(dto);
      dispatch(setDetailsAction(model));
    } catch (error) {
      if (
        typeof error === "object" &&
        error !== null &&
        "status" in error &&
        error.status === 404
      ) {
        return rejectWithValue(404);
      }
      throw error;
    }
  }
);

export const fetchFarmLandIdByArcGisIdAction = createAsyncThunk<string | null, string>(
  `${FIELDS_MODULE_NAME}/fetchFarmLandByArcGisId`,
  async (id, { dispatch }) => {
    if (id === null) {
      return null;
    }

    const dto = await dispatch(
      farmLandsApi.endpoints.fetchFarmLandByArcGisId.initiate(id, {
        subscribe: false,
        forceRefetch: true,
      })
    ).unwrap();
    return dto ? dto.id : null;
  }
);
